export class LocalDbAudio {
  constructor(db) {
    this.db = db;
  }

  getAudio(key) {
    let transaction = this.db.transaction("audio");
    let audio = transaction.objectStore("audio");
    let request = audio.get(key);

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getAudio() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  getCountAudio() {
    let transaction = this.db.transaction("audio");
    let audio = transaction.objectStore("audio");
    let request = audio.count();

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getAudio() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  saveAudio(key, value) {
    let transaction = this.db.transaction("audio", "readwrite");
    let audio = transaction.objectStore("audio");
    let data = {
      date: new Date(),
      blob: value,
    };
    let request = audio.put(
      // костыль, так как нельзя сохранять объекты, которые внутри имеют ссылки
      JSON.parse(JSON.stringify(data)),
      key
    );

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database saveAudio() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  clearAudios(date) {
    let transaction = this.db.transaction("audio", "readwrite");
    let audio = transaction.objectStore("audio");
    // let request = audio.clear();
    let request = audio.openCursor();
    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database clearAudios() error"));
      };
      request.onsuccess = function () {
        var cursor = event.target.result;
        if (cursor) {
          if (
            !date ||
            !("date" in cursor.value) ||
            (date && cursor.value.date < date)
          ) {
            var request = cursor.delete();
            request.onsuccess = function () {};
          }
          cursor.continue();
        }
        // resolve(request.result);
      };
    });
  }
}
